import React from 'react';
import { FormattedHTMLMessage, injectIntl } from 'react-intl';
import { FormFieldComponentProps } from '../../../lib/types/types';
import { InputTextComponent } from '../../FormInputs/InputText/InputText';

interface PassedProps {
    explanation?: string | JSX.Element; // eslint-disable-line
    onKeyDown?: Function;
}

export const City = ({
    value,
    isErrored,
    onChange,
    intl,
    onKeyDown = undefined,
    placeholder = '',
}: FormFieldComponentProps & PassedProps) => (
    <div className="sid-field sid-city">
        <div className="sid-l-space-top-md" />
        <label htmlFor="sid-city">
            <div className={`sid-field__label sid-l-space-btm-sm ${placeholder ? 'sid-h-screen-reader-only' : ''}`}>
                <div className="sid-field__label sid-field__label--required">
                    <FormattedHTMLMessage
                        id="city"
                        defaultMessage="City"
                    />
                </div>
            </div>
        </label>

        <InputTextComponent
            id="city"
            isErrored={isErrored}
            onChange={e => onChange(e.target.value)}
            onKeyDown={typeof onKeyDown === 'function' ? e => onKeyDown(e) : undefined}
            placeholder={placeholder || intl.formatMessage({ id: 'cityPlaceholder', defaultMessage: 'City*' })}
            value={value}
        />

        {
            isErrored ? (
                <div className="sid-field-error">
                    <FormattedHTMLMessage
                        id="errorId.invalidCity"
                        defaultMessage="Invalid city"
                    />
                </div>
            ) : null
        }
    </div>
);

export const CityComponent = injectIntl(City);
